// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAkCzyVxqoB_BNOi2L_uBUZvRqprZ4ZJLo",
  authDomain: "lead-appku.firebaseapp.com",
  projectId: "lead-appku",
  storageBucket: "lead-appku.firebasestorage.app",
  messagingSenderId: "678499774853",
  appId: "1:678499774853:web:787982f4314f35db6a94ec"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);

const auth = getAuth(app);

export default auth;
